import script from "./AppointmentRescheduleApproveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentRescheduleApproveModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentRescheduleApproveModal.vue?vue&type=style&index=0&id=0b358e35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b358e35"]])

export default __exports__